export const createMapFromDictionary = dictionaryValues => {
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  return mapDictionary;
};